import CryptoES from 'crypto-es';

export const encrypt = (plaintext, b64 = false) => {
  const ciphertext = CryptoES.AES.encrypt(plaintext, process.env.REACT_APP_SECRET).toString();
  return b64 ? btoa(ciphertext) : ciphertext;
}

export const decrypt = (ciphertext, b64 = false) => {
  const str = b64 ? atob(ciphertext) : ciphertext;
  return CryptoES.AES.decrypt(str, process.env.REACT_APP_SECRET).toString(CryptoES.enc.Utf8);
}
